import * as Rollbar from 'rollbar';
import { ErrorHandler, InjectionToken, Injectable, Injector, inject } from '@angular/core';
import { AuthService } from './shared/auth/auth.service';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

registerLocaleData(localeIt, 'it-IT');

export function rollbarFactory() {
  const rollbarConfig: Rollbar.Configuration = {
    accessToken: '7ec6bbe555524c818d3833330622e65a',
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: 'production',
    payload: {
      environment: 'production',
      client: {
        javascript: {
          source_map_enabled: true,
          code_version: '1.0',
          guess_uncaught_frames: true
        }
      }
    }
  };

  return rollbarConfig;
}

export const RollbarService = new InjectionToken<Rollbar>('rollbar');

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);
  private rollbar = inject<Rollbar>(RollbarService);


  handleError(error): void {
    console.error('Exception handled - ', error);

    const production = environment.production;
    if (production) {
      this.rollbar.error(error.originalError || error);
      const router = this.injector.get(Router);
      const authService = this.injector.get(AuthService);
      authService.logout();
      router.navigate(['/error']);
    } else {
      alert('Errore inaspettato');
    }
  }
}
